import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const SearchBar = ({ placeholder = "Cerca...", value, onChange, onSearch }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onSearch) {
      e.preventDefault();
      onSearch(e.target.value);
    }
  };

  return (
    <Form className="mb-3" onSubmit={(e) => e.preventDefault()}>
      <InputGroup className="search-bar">
        <InputGroup.Text className="bg-white border-end-0 rounded-start-pill">
          <i className="bi bi-search text-primary"></i>
        </InputGroup.Text>
        <Form.Control
          type="search"
          placeholder={placeholder}
          className="border-start-0 bg-white rounded-end-pill no-focus-outline"
          aria-label="Cerca"
          value={value}
          onChange={onChange}
          onKeyDown={handleKeyDown}
        />
      </InputGroup>
    </Form>
  );
};

export default SearchBar; 